<template>
  <!-- <div class="map-backdrop"> -->
    
  <!-- </div> -->
  <!-- <div id="map" :class="[ visible ? 'mapshow' : 'maphide' ]"> -->
  <div id="map" v-if="data.array.length && visible">
  <!-- <div v-if="data.array" style="height:600px; width:100%" :class="[ visible ? 'mapshow' : 'maphide' ]"> -->
    <l-map ref="map" :zoom="13" :center="getLastLatLon()" :maxZoom="18">
      
      
      <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" name="OpenStreetMap"
      :attribution="attribution"></l-tile-layer>
      
      <div v-for="item, itemKey in data.array" :key="item.receivedTime">
      <l-marker v-if="!itemKey" :lat-lng="[item.latitude,item.longitude]">

        <l-polyline :lat-lngs="getPolyLatLon()" color="#888" :weight="1"></l-polyline>

        <l-icon :iconSize="iconSize">
          <i :class="getAPRSSymbolImageClass(item.symboltable+item.symbolcode,32)"></i>
        </l-icon>
        <l-popup v-if="item"><MapPopup :item="item" /></l-popup>
      </l-marker>
      <l-circle-marker v-if="itemKey && item.latitude && item.longitude" :lat-lng="[item.latitude,item.longitude]" :radius="4" :weight="3" color="#ff0000" :fill="true" fillColor="#ff0000" :fillOpacity="0.7">
        <l-popup v-if="item"><MapPopup :item="item" /></l-popup>
      </l-circle-marker>
      
      </div>
    </l-map>
  </div>

</template>

<script setup>
import { ref, defineExpose } from 'vue';
import { getClearData } from '../js/fetchdata.js'
import { getAPRSSymbolImageClass } from '../js/aprssymbols.js'
import MapPopup from "./MapPopupBody.vue"

import "leaflet/dist/leaflet.css";
import { LMap, LTileLayer, LMarker, LIcon, LCircleMarker, LPolyline, LPopup } from "@vue-leaflet/vue-leaflet";
// import { LMap, LTileLayer, LCircle } from "@vue-leaflet/vue-leaflet";

// const zoom = ref(6)
// const maxZoom = ref(18)
const attribution= ref('&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors | ::APRS RADOM:: | tml')
// const markerLatLng = ref([51.396421, 21.14851])
const iconSize = ref([32,32])
// const iconAnchor = ref([12,12])

// L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
//     attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
//     maxZoom: 18
// }).addTo(aprsmap);

const visible=ref(true)

const data = ref(getClearData())
// console.log('MapBOX: '+ data.value)

// onMounted(() => {
//   initMap()
//   if (data.value.array) {
//     addFeatures(data.value.array)
//   }
// })

defineExpose({
  // initMap,
  visible,
  data,
});

// function initMap() {
//   if (data.value.array) {
//     createMap()
//   }
// }

// function createMap() {
    
//     // const homeCoord = [21.14851, 51.396421]  //this.lonlat;


//     // return map;
//     }

function getPolyLatLon() {
  let latlngs = []
  if (data.value.totalDistance) {
    for (let item in data.value.array) {
      if (data.value.array[item].latitude && data.value.array[item].longitude) {
        latlngs.push([data.value.array[item].latitude, data.value.array[item].longitude])
      }
    }
  }
  return latlngs
}

function getLastLatLon() {  
  // console.log('getLastLatLon(): ',data.value.array)
  let result = []
  for (let i = 0; i < data.value.array.length; i++) {
    if (data.value.array[i].latitude && data.value.array[i].longitude) {
      result = [data.value.array[i].latitude, data.value.array[i].longitude]
      break;
    }
  }
  // console.log('getLastLatLon(): ',result)
  return result
}

</script>

<style scoped>
/* .map-backdrop {
  position: fixed;
  top: 200px;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
} */

#map {
  width: 100%;
  height: 700px;
  /* display: none; */
  /* position: fixed;   */
  justify-content: center;
  align-items: center;

  /* position:fixed!important;
  width:100%!important;
  height:100%!important;
  top:0!important;
  left:0!important;
  z-index:99999; */
}

/* .mapshow {
  display: block;
}

.maphide {
  display: none;
} */

</style>
